module.exports = __webpack_public_path__ + "static/media/ANKLE BELT - (Gejje)-ink.4bc9471e.jpeg";